import { magSq } from "./magsq";
export var mag = function mag(v) {
  return Math.sqrt(magSq(v));
};